module.exports = __webpack_public_path__ + "img/storage_two.ca7c4aac.jpg";